var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBga(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5376,
    height: 3827,
    viewBox: "0 0 5376 3827",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bga_svg__clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2273.14 759.146C2230.55 915.76 2210.8 1082 2217.7 1253.56c24.24 603.63 371.95 1115.08 862.7 1361.77 42.58-156.61 62.33-322.85 55.44-494.41-24.25-603.63-371.96-1115.08-862.7-1361.774z",
    fill: "url(#bga_svg__paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2217.75 1253.46c-6.89-171.56 12.86-337.794 55.45-494.408-218.61-109.894-465.6-167.301-725.05-156.879C706.326 635.989 52.289 1370.74 87.339 2243.29c35.05 872.54 745.915 1552.47 1587.741 1518.65 676.32-27.17 1231.38-506.74 1405.37-1146.7-490.74-246.73-838.45-758.15-862.7-1361.78z",
    fill: "url(#bga_svg__paint1_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3678.51-387.559c-676.32 27.168-1231.38 506.743-1405.37 1146.705 490.75 246.724 838.45 758.144 862.7 1361.774 6.89 171.56-12.86 337.8-55.44 494.41 218.6 109.89 465.59 167.3 725.04 156.88 841.83-33.82 1495.86-768.57 1460.81-1641.12-35.05-872.54-745.91-1552.465-1587.74-1518.649z",
    fill: "url(#bga_svg__paint2_linear_0_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bga_svg__paint0_linear_0_4",
    x1: 2293.52,
    y1: 820.157,
    x2: 2158.47,
    y2: 1500.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bga_svg__paint1_linear_0_4",
    x1: 1780.96,
    y1: 517.995,
    x2: 2098.89,
    y2: 959.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bga_svg__paint2_linear_0_4",
    x1: 3093.85,
    y1: -79.272,
    x2: 2609.79,
    y2: 1005.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#25F4EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bga_svg__clip0_0_4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-2.3 5242.204 87.826)",
    d: "M0 0h5233.84v3619.36H0z"
  })))));
}
export default SvgBga;